module.exports = __webpack_public_path__ + "media/images/ui-icons_777620_256x240-5dfa8b61.png";